import "../styles/CompanyBrochureCTA.scss";

const CompanyBrochureCTA = () => {
  return (
    <section className="presentation-cta">
      <div className="presentation-cta__content">
        <h2>Conoce nuestra trayectoria</h2>
        <p>
          Descubre quiénes somos, nuestra experiencia y por qué somos
          especialistas en vidrio y aluminio.
        </p>

        <a
          href="https://luvitecvidrioyaluminio.com/cv.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="presentation-cta__button"
        >
          Descargar carta de presentación
        </a>
      </div>
    </section>
  );
};

export default CompanyBrochureCTA;
